import { render, staticRenderFns } from "./PublicationPage.vue?vue&type=template&id=b9abff40&"
import script from "./PublicationPage.vue?vue&type=script&lang=js&"
export * from "./PublicationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports